import React from 'react';
import ReactDOM from 'react-dom';
import { Phone, PhoneOff, PhoneIncoming } from 'lucide-react';
import { useVoiceStore } from '../../store/voiceStore';

const IncomingCallNotification: React.FC = () => {
  const { isCallIncoming, incomingCallFrom, answerDmCall, rejectIncomingCall } = useVoiceStore();

  if (!isCallIncoming || !incomingCallFrom) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 right-0 z-[250] flex justify-center pointer-events-none">
      <div className="pointer-events-auto mt-3 mx-4 max-w-lg w-full animate-slide-down">
        <div className="bg-bg-secondary/95 backdrop-blur-xl border border-border-color rounded-2xl shadow-2xl shadow-black/40 px-4 py-3 flex items-center gap-3">
          {/* Pulsing ring indicator */}
          <div className="relative flex-shrink-0">
            <div className="absolute inset-0 -m-1 rounded-full bg-success/20 animate-ping" />
            <div className="relative w-10 h-10 rounded-full overflow-hidden border-2 border-success/50">
              {incomingCallFrom.avatar_url ? (
                <img
                  src={incomingCallFrom.avatar_url}
                  alt={incomingCallFrom.username}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-accent-color flex items-center justify-center text-white font-bold text-sm">
                  {incomingCallFrom.username.charAt(0).toUpperCase()}
                </div>
              )}
            </div>
          </div>

          {/* Info */}
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold text-text-primary truncate">
              {incomingCallFrom.username}
            </div>
            <div className="flex items-center gap-1.5 text-xs text-success">
              <PhoneIncoming className="w-3 h-3" />
              <span className="animate-pulse">Appel entrant...</span>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={() => answerDmCall()}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-success hover:bg-success/90 text-white text-xs font-semibold transition-all hover:scale-105 active:scale-95 shadow-lg shadow-success/25"
            >
              <Phone className="w-3.5 h-3.5" />
              Accepter
            </button>
            <button
              onClick={() => rejectIncomingCall()}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-error/90 hover:bg-error text-white text-xs font-semibold transition-all hover:scale-105 active:scale-95 shadow-lg shadow-error/25"
            >
              <PhoneOff className="w-3.5 h-3.5" />
              Refuser
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default IncomingCallNotification;